// extracted by mini-css-extract-plugin
export default {"advertDetailServiceList":"c-o_fj","advertDetailServiceList__header":"c-o_fk","advertDetailServiceList__list":"c-o_fl"};